"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation createPlatformFee($fee: FeeInput!) {
    createPlatformFee(fee: $fee) {
      _id
      name
      orgId
      eventId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      paymentMethods
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
      paymentMethods
    }
  }
`;
exports.default = query;
//# sourceMappingURL=createPlatformFee.mutation.js.map